// extracted by mini-css-extract-plugin
export var cell = "_75-4";
export var headerCell = "_75-2";
export var rowHeader = "_75-3";
export var table = "_75-1";
export var tableContainer = "_75-0";